module.exports = __webpack_public_path__ + "static/media/YF54_0.d133b025.jpg";